import React from 'react';
import { connect } from 'react-redux';
import { EnvType } from "./constants";
import HighlightItem from './highlight-item';
import thin_left_chevron from '../../assets/svod/buttons/thin-left-chevron.png';
import thin_right_chevron from '../../assets/svod/buttons/thin-right-chevron.png';

class HighlightRow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			scrollPosition: 0,
			indicatorIdx: 0,
		};

		this.getHighlightInfo = this.getHighlightInfo.bind(this);
		this.getHighlightVideoIds = this.getHighlightVideoIds.bind(this);
		this.slideLeft = this.slideLeft.bind(this);
		this.slideRight = this.slideRight.bind(this);
	}

	componentDidUpdate() {
		let vidItems = document.getElementsByClassName(`videoItem-highlight`);
		document.documentElement.style.setProperty('--lolomo-scroll', `${this.state.scrollPosition}px`);
		for (let i = 0; i < vidItems.length; i++) {
			vidItems[i].style.transform = `translateX(${this.state.scrollPosition}px`;
		}
	}


	getHighlightInfo() {
		let HighlightRowString = this.props.label;
		let rowTitle = (HighlightRowString.split("_")[0]);
		let rowId = (HighlightRowString.split("_")[1]);

		return { rowTitle, rowId };
	}

	getHighlightVideoIds() {
		let highlightVideoObjects = this.props.videos;
		let videoIds = Object.keys(highlightVideoObjects);

		return videoIds;
	}

	slideLeft() {
		let scrollAmount = document.body.clientWidth;

		let newPos = this.state.scrollPosition + scrollAmount;
		let newIndex = this.state.indicatorIdx;
		if (newPos >= 1) newPos = 0;
		if (this.state.indicatorIdx > 0) newIndex -= 1;

		let videoIds = this.getHighlightVideoIds();
		if (newIndex < 0) newIndex = 0;
		let highlight_in_view = videoIds[newIndex];

		this.props.eventHandler({ 
			data: { 
				event_type: "button_click", 
				type: "scroll_click", 
				row_name: this.getHighlightInfo().rowTitle, 
				row_id: this.getHighlightInfo().rowId,
				direction: 'left',
				highlight_in_view: highlight_in_view,
				page_location: "home_page",
				time: Date.now() 
			} 
		});

		this.setState({ scrollPosition: newPos, indicatorIdx: newIndex });
	}

	slideRight() {
		let lolomoWidth = document.getElementById(`highlight-slide`).scrollWidth;
		let scrollAmount = document.body.clientWidth;
		let newPos = this.state.scrollPosition - scrollAmount;
		let newIndex = this.state.indicatorIdx + 1;
		if (newPos < (-lolomoWidth + scrollAmount)) {
			newPos = 0;
			newIndex = 0;
		}
		let videoIds = this.getHighlightVideoIds();
		if (newIndex >= videoIds.length) newIndex = 0;
		let highlight_in_view = videoIds[newIndex];

		this.props.eventHandler({ 
			data: { 
				event_type: "button_click", 
				type: "scroll_click", 
				row_name: this.getHighlightInfo().rowTitle, 
				row_id: this.getHighlightInfo().rowId,
				direction: 'right',
				page_location: "home_page",
				highlight_in_view: highlight_in_view,
				time: Date.now() 
			} 
		});

		this.setState({ scrollPosition: newPos, indicatorIdx: newIndex });
	}

	render() {
		const { 
			environment,
			label
		} = this.props;

		let videoIds = this.getHighlightVideoIds();

		let highlightItemList = videoIds.map((highlightId, idx) => {
			let activeHighlight = false;
			if (this.state.indicatorIdx === idx) {
				activeHighlight = true;
			}
			let highlight = this.props.videos[highlightId];

			return (<HighlightItem {...this.props} label={label} videoObject={highlight} key={`highlight`} activeHighlight={activeHighlight} index={idx} />);
		});

		let carouselPos = (highlightItemList.map((highlight, idx) => {
			if (this.state.indicatorIdx === idx) {
				return (<li className="carousel-list-item-selected" key="carousel"></li>);
			} else {
				return (<li className="carousel-list-item" key="carousel"></li>);
			}
		}));
		
		if (highlightItemList.length > 0) {
			switch(environment) {
				case EnvType.NETFLIX: {
					return (
						<div className="" id="highlight-slide">
							{highlightItemList[0]}
						</div>
					);
				}
				case EnvType.AMAZON: {
					if (highlightItemList.length > 1) {
						return (
							<div className="highlight-row" id="highlight-slide">
								<button className="scrollLeft" id={`slide-left-highlight`} onClick={this.slideLeft} > <i className="fas fa-chevron-left"></i></button>
								<button className="scrollRight" id={`slide-right-highlight`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
								{highlightItemList}
								<ul className="carousel-list">
									{carouselPos}
								</ul>
							</div>
						);
					} else {
						return (
							<div className="highlight-row" id="highlight-slide">
								{highlightItemList[0]}
							</div>
						);
					}
				}
				case EnvType.APPLETV: {
					if (highlightItemList.length > 1) {
						return (
							<div className="highlight-row" id="highlight-slide">
								{this.state.scrollPosition != 0 && (
									<button className="scrollLeft scrollButton" id={`slide-left-highlight`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
								)}
								<button className="scrollRight scrollButton" id={`slide-right-highlight`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
								{highlightItemList}
							</div>
						);
					} else {
						return (
							<div className="highlight-row" id="highlight-slide">
								{highlightItemList[0]}
							</div>
						);
					}
				}
				case EnvType.PEACOCK: {
					if (highlightItemList.length > 1) {
						return (
							<div className="highlight-row" id="highlight-slide">
								<button className="scrollButton scrollLeft" id={`slide-left-highlight`} onClick={this.slideLeft} > <i className="fas fa-chevron-left"></i></button>
								<button className="scrollButton scrollRight" id={`slide-right-highlight`} onClick={this.slideRight} ><i className="fas fa-chevron-right"></i></button>
								{highlightItemList}
								<ul className="carousel-list">
									{carouselPos}
								</ul>
							</div>
						);
					} else {
						return (
							<div className="highlight-row" id="highlight-slide">
								{highlightItemList[0]}
							</div>
						);
					}
				}
				default: {
					return (
						<div className="" id="highlight-slide">
							{highlightItemList[0]}
						</div>
					);
				}
			}
		}
	}
}


const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	volume: state.SVOD.volume,
	profilePictureNumber: state.SVOD.profilePictureNumber,
	environment: state.SVOD.environment,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	isSurveyActive: state.SVOD.isSurveyActive,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
});

const mapDispatchToProps = (dispatch, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(HighlightRow);



// WEBPACK FOOTER //
// ./src/components/svod/highlight-row.jsx